<template>
  <div>
    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col cols="12" class="d-flex justify-end">
        <TableButtonComp @click="addItem" normalButton text-button="Crear grado" iconBut="fas fa-plus" />
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" class="pl-5 pr-5" v-if="this.GradosMantenimiento.length < 1">
        <v-card outlined>
          <v-card-text style="min-height:200px" class="text-center d-flex align-center justify-center">
            Aún no has agregado ningún grado al colegio
          </v-card-text>
        </v-card>

      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-center" v-for="grado of GradosMantenimiento" :key="grado.id">
        <v-card :color="grado.ck1_mant_niveles[0].color" width="240" dark elevation="7">
          <v-list-item three-line>
            <v-list-item-content class="py-0">
              <span class="mb-1">
                <h3>{{ grado.desc_grado }}</h3>
                {{ grado.ck1_mant_niveles[0].desc_nivel }}
              </span>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions class="white">
            <v-spacer />

            <TableButtonComp editButton v-if="componenteEvento.editar_submodulo" @click="editItem(grado)"
              tooltipText="Editar grado" />

            <TableButtonComp deleteButton v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(grado)"
              tooltipText="Eliminar grado" class="mx-2" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- {{ GradosMantenimiento }} -->


    <!-- <ComundataTableComp :headers="ConfigGradosWebmasterHeaders" :items="GradosMantenimiento" whitSearch
      placeholderTextsearch="Buscar grado" noResultsText="Sin grados registrados">
      <template v-slot:desc_nivel="{ item }">
        <div class="chip" :style="{ background: item.ck1_mant_niveles[0].color }">
          {{ item.ck1_mant_niveles[0].desc_nivel }}
        </div>
      </template>

      <template v-slot:action_editar="{ item }">
        <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
          tooltipText="Editar grado" />
      </template>
      <template v-slot:action_borrar="{ item }">
        <TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" deleteButton
          tooltipText="Eliminar grado" />
      </template>
    </ComundataTableComp> -->
    <!--  FIN lIST DE REGISTROS --->

    <!-- modal para crear editar Grados -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog" :title="formTitle" @close-modal="dialog = false" max-width="450">
        <template v-slot:body>
          <v-row>
            <!-- {{NivelesMantenimiento}} -->
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <AutocompleteComp @change="getGradosCk1Nivel()" v-model="editedItem.id_nivel" textLabel="Nivel"
                :items="NivelesMantenimiento" item-value="id" item-text="desc_nivel"
                :rules="validationRules.validateNivel" :readonly="bloquearCampo" />
            </v-col>

            <!-- {{ GradosCk1 }} -->
            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-autocomplete v-if="evento === 'agregar'" v-model="gradoSistema" label="Grado" :items="GradosCk1"
                item-value="id" item-text="desc_grado" :rules="validationRules.validateGrado" :disabled="bloquearCampo"
                multiple return-object>
              </v-autocomplete>


              <AutocompleteComp v-else v-model="editedItem.id_grado_clickone" textLabel="Grado" :items="GradosCk1"
                item-value="id" item-text="desc_grado" :rules="validationRules.validateGrado"
                :isDisable="bloquearCampo" />

            </v-col>

            <v-col cols="12" sm="12" md="12" v-if="evento == 'editar'" class="py-0">
              <textfieldComp v-model="editedItem.desc_grado" textLabel="Nombre del grado" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp v-if="evento == 'editar'" @click="editGrado(editedItem.id)" normalButton iconBut="fas fa-save"
            text-button="Guardar Cambios" />

          <TableButtonComp v-if="evento == 'agregar'" @click="addNewGrado" normalButton text-button="Guardar"
            iconBut="fas fa-save" />
        </template>
      </ComunDialogComp>
    </v-form>
    <!--------->

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
    <ComunDialogComp Deletedialog titleWindow="Eliminar grado" v-model="dialog_confirm"
      @close-modal="dialog_confirm = false" @cancel-item="funcionConfirm('no')" @delete-item="funcionConfirm('si')">
      <template v-slot:body>
        {{ desc_confirm }}
        <v-chip color="primary" label dense>
          {{ name_confirm }}
        </v-chip>
      </template>
    </ComunDialogComp>

    <!-- fin de modal de borrar registro -->
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
// eslint-disable-next-line
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
// import ComundataTableComp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import textfieldComp from "../../../../components/ComponentsEst/textfieldComp.vue";
import { ConfigGradosWebmasterHeaders } from "../../../../helpers/headersTable.js";
import { validationRules } from "../../../../helpers/validatorHelpers.js";

export default {
  name: "grados",

  props: ["GradosMantenimiento"],
  components: {
    TableButtonComp,
    // ComundataTableComp,
    ComunDialogComp,
    AutocompleteComp,
    textfieldComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 35, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    ConfigGradosWebmasterHeaders,
    search: "",

    // modal agregar editar grado
    dialog: false,
    evento: "",
    editedItem: [],
    NivelesMantenimiento: [],
    GradosCk1: [],
    gradoSistema: [],

    bloquearCampo: false,
    /////////////////////////////////

    // modal confirmacion
    name_confirm: "",
    id_delete: null,
    dialog_confirm: false,
    desc_confirm: "",
    eventoConfirm: "",
    //////////////////////////////////
  }),

  computed: {
    validationRules() {
      return validationRules;
    },

    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear grado" : "Editar grado";
    },
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ...mapActions("nivelesGrados", []),

    ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
    async limpiarForm() {
      (this.editedItem = {
        id: 0,
        id_colegio: parseInt(this.datoLogin.id_colegio, 10),
        id_nivel: 0,
        id_grado_clickone: "",
        desc_grado: "",
        id_nivel_clickone: "",
        id_usuario: parseInt(this.datoLogin.id, 10),
        ck1: 0,
      }),
        (this.NivelesMantenimiento = []),
        (this.GradosCk1 = []);
      console.log('Tipo de Item', typeof this.GradosCk1);

      this.$refs.formDatos.resetValidation();
    },

    //////// METODO PARA HABILITAR MODAL PARA AGREGAR UN ITEM NUEVO //
    addItem() {
      this.getNivelesMantenimiento();
      this.evento = "agregar";
      this.limpiarForm();
      this.bloquearCampo = false;

      this.dialog = true;
    },

    // -- que lista todos los niveles de un colegio indicado. Recibe el Id del colegio a cosultar
    //------------Niveles de mantenimiento --------
    async getNivelesMantenimiento() {
      var id = this.datoLogin.id_colegio;

      try {
        let response = await axios.get("/mantenimiento/nivel/" + id + "");
        this.NivelesMantenimiento = response.data;
        //console.log(this.NivelesMantenimiento)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //********** metodo para traer los grados segun pais y nivel de ck1 */
    async getGradosCk1Nivel() {
      let filtroNivelCk1 = this.NivelesMantenimiento.filter(
        (el) => el.id == this.editedItem.id_nivel
      );
      this.editedItem.id_nivel_clickone = filtroNivelCk1[0].id_nivel_clickone;

      let params = {
        cid: sessionStorage.id_colegio,
        id_pais: sessionStorage.id_pais,
        id_nivel: this.editedItem.id_nivel_clickone,
      };

      try {
        let response = await axios.post(
          "/mantenimiento/grado/mgn/list/",
          params
        );
        this.GradosCk1 = response.data;


        if (response.data.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje:
              "El nivel seleccionado ya tiene todos los grados asignados",
            tiempo: null,
          });
        }
        //console.log(this.GradosCk1)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
      finally {
        this.gradoSistema = []
      }
    },
    //////////////////////////////////////////////////////////////////

    ///////// añadir nivel a valor y a campo nombre
    // addGradoMinedu(item) {
    //   let filtroGrado = this.GradosCk1.filter((el) => el.id == item);

    //   this.editedItem.desc_grado = filtroGrado[0].desc_grado;
    // },
    /////////////////////////////////////////

    async addNewGrado() {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedItem;

        let paramsGrados = this.gradoSistema.map((item) => {
          return {
            ...params,
            id_grado_clickone: item.id,
            desc_grado: item.desc_grado
          }
        });

        if (paramsGrados.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "Debe seleccionar al menos un grado",
            tiempo: null,
          });
          return;
        }

        try {
          let response = await axios.post("/mantenimiento/grado/", paramsGrados);

          if (response.data.messageT == "S") {
            this.getGradosMantenimiento();
            this.dialog = false;
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    //********  funcion por props para comunicacion de actualizacion de grado ****/
    getGradosMantenimiento() {
      this.$emit("getAllGradosMantenimiento");
    },

    agregarOtroGrado() {
      this.eventoConfirm = "agregarOtroGrado";
      this.dialog_confirm = true;

      this.desc_confirm = "¿Desea agregar otro grado al nivel?";
      this.name_confirm = `Nivel: ${this.editedItem.desc_grado}`   //Seteamos su nuevo valor para mostrarlo en el proximo modal 
    },

    //------------FUNCION CONFIRMAR -------------
    async funcionConfirm(resp) {
      if (resp == "si" && this.eventoConfirm == "borrar") {
        this.deleteGrado();
      } else if (resp == "no" && this.eventoConfirm == "borrar") {
        this.dialog_confirm = false;
      } else if (resp == "si" && this.eventoConfirm == "agregarOtroGrado") {
        this.dialog_confirm = false;

        this.getGradosCk1Nivel();
        this.editedItem.desc_grado = "";
        this.$refs.formDatos.resetValidation();
      } else {
        this.dialog_confirm = false;
        this.dialog = false;
      }
    },

    //---------obtener datos pàra editar
    editItem(item) {
      this.limpiarForm();
      this.evento = "editar";
      this.bloquearCampo = true;

      //console.log(item)
      this.getNivelesMantenimiento();
      this.editedItem = Object.assign({}, item);
      this.getGradosCk1Niveledit(item.id_grado_clickone);

      this.dialog = true;
    },

    async getGradosCk1Niveledit(id) {
      try {
        let response = await axios.get("/manager/gradoCkOne/" + id + "");
        this.GradosCk1 = response.data;
        //console.log(JSON.stringify(this.GradosCk1Edit));
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //----------------editar Grado ----------------
    async editGrado(id) {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedItem;

        try {
          let response = await axios.put("/mantenimiento/grado/" + id, params);

          if (response.data.messageT == "S") {
            this.getGradosMantenimiento();

            this.dialog = false;
            this.limpiarForm();
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    // *****  confirmar el eliminar **********
    deleteConfirm(item) {
      this.eventoConfirm = "borrar";
      this.dialog_confirm = true;
      this.id_delete = item.id;
      this.name_confirm = `Grado: ${item.desc_grado}`;
      this.desc_confirm = "¿Está seguro de eliminar este registro?";
    },

    //-- 26-02-2020. ROBERT.
    //-- METODO QUE PERMITE ELIMINAR UN GRADO DEL AMBITO DE MANTENIMIENTO
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    //------------borrar Grado -------------
    async deleteGrado() {
      try {
        let response = await axios.delete(
          "/mantenimiento/grado/" + this.id_delete
        );
        this.dialog_confirm = false;

        if (response.data.messageT == "S") {
          this.getGradosMantenimiento();
        }

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>

<style scoped>
.chip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 15px;
  color: #ffffff;
}
</style>
